import React from 'react';

import { ResponsiveDrawerInterface } from '@components/views/components/listing/drawer/ResponsiveSearchDrawerItem';
import SelectedComponent from '@shared/searchBar/datePicker/selectedComponent';
import EmptyComp from '@shared/searchBar/datePicker/emptyComp';
import { formatMomentDate, formatShortLocalDate } from '@utils/dateUtil';
import { Col } from '@components/formStyles';

import { ResponsiveSearchDrawerItemContent } from './styled';
import { Label } from '../styled';

const HotelResponsiveSearchDrawerItem: React.FC<ResponsiveDrawerInterface> = ({
  onClick = () => false,
  startDate,
  endDate,
  showLabel = false,
}) => {
  return (
    <ResponsiveSearchDrawerItemContent
      role='button'
      tabIndex={-1}
      onClick={onClick}
    >
      {!startDate ? (
        <Col>
          {showLabel && <Label>Giriş</Label>}
          <EmptyComp label='Giriş' />
        </Col>
      ) : (
        <Col>
          {showLabel && <Label>Giriş</Label>}
          <SelectedComponent
            value={formatShortLocalDate(formatMomentDate(startDate)) || ''}
            label='Giriş'
            rightBorder
          />
        </Col>
      )}

      {!endDate ? (
        <Col>
          {showLabel && <Label>Çıkış</Label>}
          <EmptyComp label='Çıkış' />
        </Col>
      ) : (
        <Col>
          {showLabel && <Label>Çıkış</Label>}
          <SelectedComponent
            value={formatShortLocalDate(formatMomentDate(endDate)) || ''}
            label='Çıkış'
            rightBorder
          />
        </Col>
      )}
    </ResponsiveSearchDrawerItemContent>
  );
};

export default HotelResponsiveSearchDrawerItem;
